import React from "react";
import {
  Mail,
  PhoneCall,
  Users,
  MessageSquare,
  Calendar,
  Coffee,
  UtensilsCrossed,
  Heart,
  Gift,
  FileText,
  ArrowDownLeft,
  ArrowUpRight,
} from "lucide-react";
import { useApp } from "../../context/AppContext";
import { CONTACT_LOG_TYPES } from "../../constants/contactTypes";
import { FONT_SIZES, ICON_SIZES } from "../../constants/appConfig";
import { Badge } from "../ui/Badge";
import { isCfreHolder } from "../../utils/memberHelpers";

export const PathwayBadge = ({ stage, effective, small }) => {
  const { pathways } = useApp();
  // If an effective pathway object is provided, use it directly
  if (effective) {
    return <Badge label={effective.label} color={effective.color} small={small} />;
  }
  const info = pathways.find((p) => p.id === stage) || pathways[0];
  return <Badge label={info.name} color={info.color} small={small} />;
};

export const DonorFlags = ({ member, effective, small = false }) => {
  const { palette } = useApp();
  return (
    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
      <PathwayBadge stage={member.pathway} effective={effective} small={small} />
      {member.isDonor && (
        <Badge label="Donor" color={palette.tagDonor} small={small} />
      )}
      {member.isBoardMember && (
        <Badge label="Board" color={palette.tagBoard} small={small} />
      )}
      {member.isRecurring && (
        <Badge label="Recurring" color="#0ea5e9" small={small} />
      )}
      {(member.status === "lapsed" || member.status === "suspended") && (
        <Badge
          label={member.status === "suspended" ? "SUSPENDED" : "LAPSED"}
          color="#f59e0b"
          small={small}
        />
      )}
    </div>
  );
};

const ICON_MAP = {
  email: Mail,
  phone: PhoneCall,
  meeting: Users,
  text: MessageSquare,
  event: Calendar,
  coffee: Coffee,
  lunch: UtensilsCrossed,
  volunteering: Heart,
  donation: Gift,
  note: FileText,
};

export const ContactLogIcon = ({ type, size = 14 }) => {
  const Icon = ICON_MAP[type] || Mail;
  const info = CONTACT_LOG_TYPES.find((t) => t.id === type);
  return <Icon size={size} style={{ color: info?.color || "#6b7280" }} />;
};

// ── Direction indicator for contact log entries ───────────────
// Shows a small arrow icon next to the contact type icon
// to indicate whether the contact was inbound or outbound
export const DirectionIndicator = ({ direction, size = 10 }) => {
  if (!direction || direction === "inbound") {
    return (
      <ArrowDownLeft
        size={size}
        style={{ color: "#059669", flexShrink: 0 }}
        title="Inbound — donor initiated"
      />
    );
  }
  return (
    <ArrowUpRight
      size={size}
      style={{ color: "#9ca3af", flexShrink: 0 }}
      title="Outbound — you initiated"
    />
  );
};

export const InfoLine = ({ icon: Icon, text }) => {
  const { palette } = useApp();
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: FONT_SIZES.xs,
        color: palette.text3,
        fontWeight: 400,
      }}
    >
      <Icon
        size={ICON_SIZES.xs}
        style={{ flexShrink: 0, color: palette.text3, opacity: 0.6 }}
      />
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </span>
    </div>
  );
};
